import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  manageSettings: {
    description: 'Link to the SmartFill Settings page',
    defaultMessage: 'Manage Settings',
    id: '6phDeJ',
  },
  smartFillApplied: {
    description: 'meesage displayed in the CSW when the order has been prepopulated with SmartFill data',
    defaultMessage: 'SmartFill applied',
    id: 'y6cBKk',
  },
});
